// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/font/pretendard.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: Pretendard !important;
}

.app {
    text-align: center;
    width: 100%;
    height: 100%;
    background: #FFFFFF;
}

.top {
    width: 100%;
    height: 50px;
    background: #DDEECC;
}

.main_content {
    display: flex;
    width: 100vw;
    height: calc(100vh - 50px);
    flex-direction: row;
}

.side {
    width: 305px;
    height: calc(100vh - 50px);
    background: #dcdcdc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.content {
    height: 100%;
    flex-grow: 1;
    background: #FFFFFF;
}

.loading_icon {
    border: 2px solid #ddd;
    border-radius: 50%;
    border-top-color: #333;
    animation: spin 1s infinite cubic-bezier(0.55, 0.15, 0.45, 0.85);
}

.page_title {
    display: flex;
    align-items: center;
    text-align: start;
    margin-left: 15px;
    font-size: 20px;
    font-weight: 700;
    gap: 10px;
}

div::-webkit-scrollbar {
    width: 4px;
    border: none;
    border-radius: 10px;
}

/* 스크롤바 막대 꾸미기 */
div::-webkit-scrollbar-thumb {
    background: #426AE6;
    border-radius: 10px;
}

/* 스크롤바 트랙 꾸미기 */
div::-webkit-scrollbar-track {
    background: #426AE633;
    border-radius: 10px;
}
div::-webkit-scrollbar-button {
    display: none;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,gEAAgE;AACpE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":["@import \"./assets/font/pretendard.css\";\r\n\r\n* {\r\n    font-family: Pretendard !important;\r\n}\r\n\r\n.app {\r\n    text-align: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #FFFFFF;\r\n}\r\n\r\n.top {\r\n    width: 100%;\r\n    height: 50px;\r\n    background: #DDEECC;\r\n}\r\n\r\n.main_content {\r\n    display: flex;\r\n    width: 100vw;\r\n    height: calc(100vh - 50px);\r\n    flex-direction: row;\r\n}\r\n\r\n.side {\r\n    width: 305px;\r\n    height: calc(100vh - 50px);\r\n    background: #dcdcdc;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n\r\n.content {\r\n    height: 100%;\r\n    flex-grow: 1;\r\n    background: #FFFFFF;\r\n}\r\n\r\n.loading_icon {\r\n    border: 2px solid #ddd;\r\n    border-radius: 50%;\r\n    border-top-color: #333;\r\n    animation: spin 1s infinite cubic-bezier(0.55, 0.15, 0.45, 0.85);\r\n}\r\n\r\n.page_title {\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: start;\r\n    margin-left: 15px;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    gap: 10px;\r\n}\r\n\r\ndiv::-webkit-scrollbar {\r\n    width: 4px;\r\n    border: none;\r\n    border-radius: 10px;\r\n}\r\n\r\n/* 스크롤바 막대 꾸미기 */\r\ndiv::-webkit-scrollbar-thumb {\r\n    background: #426AE6;\r\n    border-radius: 10px;\r\n}\r\n\r\n/* 스크롤바 트랙 꾸미기 */\r\ndiv::-webkit-scrollbar-track {\r\n    background: #426AE633;\r\n    border-radius: 10px;\r\n}\r\ndiv::-webkit-scrollbar-button {\r\n    display: none;\r\n}\r\n\r\n@keyframes spin {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
